<script>
import RequestsForm from "@components/support-areas/internal-control/condusef/requests-form.vue";

export default {
  name: "complaint-reports",
  components: {RequestsForm},
}
</script>

<template>
  <div class="container mt-10">
    <span class="px-5 pill-danger pulse-danger">Sanbox</span>

    <vx-card title="Consultas Generales" class="mt-5">
      <requests-form @onSaved="() => {}" />
    </vx-card>
  </div>
</template>

<style scoped>

</style>